import { FC } from 'react';
import { Text } from '@mofid-securities/uikit';

const Header: FC = () => {
  return (
    <>
      <Text
        className="mb-2 text-gray-filled-primary-enabled"
        component="h2"
        size="sm"
        weight="demibold"
      >
        تحلیل هوش مصنوعی
      </Text>
      <Text
        className=" text-gray-filled-secondary-enabled"
        component="p"
        size="xs"
        weight="medium"
      >
        هوش مصنوعی، اخبار مرتبط با صندوق شما را از منابع معتبر بررسی کرده و
        مهم‌ترین نکات و روندهای بازار را استخراج می‌کند. این اطلاعات به شما کمک
        می‌کند تصمیمات آگاهانه‌تری بگیرید.
      </Text>
    </>
  );
};

export { Header };
